import { useParams } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useEffect, useState } from "react";
import AdDetails from "../../../UI/UserAds/details/AdDetails";
import { LinearProgress } from "@mui/material";

export const AdDetailsPage = () => {
  const { id } = useParams();
  const [ad, setAd] = useState(null); // Initialize as null instead of empty object
  const [isLoading, setIsLoading] = useState(true); // Start with true
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAd = async () => {
      try {
        const { response, message } = await Helper.Get({
          url: `${api_Routes.UserAds.GetOnt}/${id}`,
        });

        if (response) {
          console.log("ehhhh");
          setAd(response?.data);
        } else {
          setError(new Error("Ad not found"));
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAd();
  }, [id]);

  if (isLoading) return <LinearProgress />;
  if (error) return <div>Error loading ad: {error.message}</div>;

  return <AdDetails ad={ad} />;
};
